import React from "react"
import * as Icon from "react-feather"

// Cloud Infrastructure Images
import CercleShape from "../../images/services-right-image/cercle-shape.png"
import ServiceRightMainPic from "../../images/services-right-image/service-right-main-pic.png"

// Web & Mobile Images
import ServiceLeftMainPic from "../../images/services-left-image/service-left-main-pic.png"

const ServicesArea = () => {
  return (
    <>
      {/* Backend & Cloud Section */}
      <div className="services-area ptb-80 bg-f7fafd">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 services-content">
              <div className="section-title">
                <h2>Backend Engineering & Cloud Infrastructure</h2>
                <div className="bar"></div>
                <p>
                  We architect secure, scalable backend systems and deploy
                  high-performance applications using modern cloud and DevOps practices.
                </p>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Database /> Database Design & Optimization
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Globe /> CI/CD & Deployment
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.File /> Secure Data Management
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.TrendingUp /> Application Performance Tuning
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Folder /> Disaster Recovery & Backups
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Monitor /> Server & DevOps Management
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Mail /> Email & SMTP Integration
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Cloud /> Cloud Architecture & Migration
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="services-right-image">
                <img
                  src={CercleShape}
                  className="bg-image rotateme"
                  alt="shape"
                />
                <img src={ServiceRightMainPic} alt="backend-cloud" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Web & Mobile Section */}
      <div className="services-area ptb-80">
        <div className="container">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="services-left-image">
                <img
                  src={CercleShape}
                  className="bg-image rotateme"
                  alt="shape"
                />
                <img src={ServiceLeftMainPic} alt="web-mobile" />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 services-content">
              <div className="section-title">
                <h2>Full-Stack Web & Mobile Development</h2>
                <div className="bar"></div>
                <p>
                  We build robust web and mobile applications with clean code,
                  scalable architecture, and seamless user experiences.
                </p>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Layout /> UI Engineering
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Code /> MERN & Modern Web Development
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Smartphone /> Android App Development
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Code /> RESTful API Development
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Smartphone /> iOS App Development
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.Percent /> UX Research & Design
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.ShoppingCart /> E-commerce Platforms
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="box">
                    <Icon.CheckCircle /> Testing & Quality Assurance
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServicesArea